// Tick/checkmark icon (matches icon-tick.svg)
export const TickIcon = ({ className = '' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7715 3.8511C14.0378 4.10533 14.0476 4.52732 13.7934 4.79366L6.79339 12.127C6.66946 12.2568 6.49839 12.3312 6.31891 12.3333C6.13942 12.3354 5.96668 12.265 5.83975 12.1381L3.50642 9.80474C3.24607 9.54439 3.24607 9.12228 3.50642 8.86194C3.76677 8.60159 4.18888 8.60159 4.44923 8.86194L6.30007 10.7128L12.8289 3.87302C13.0831 3.60669 13.5051 3.59688 13.7715 3.8511Z"
      fill="currentColor"
    />
  </svg>
);

// Arrow down icon (matches icon-arrow-down-01.svg)
export const ArrowDownIcon = ({ className = 'field-dropdown-chevron' }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4418 7.05785C15.6858 7.30193 15.6858 7.69766 15.4418 7.94174L10.4418 12.9417C10.1977 13.1858 9.802 13.1858 9.55792 12.9417L4.55788 7.94178C4.3138 7.69771 4.3138 7.30198 4.55787 7.0579C4.80195 6.81382 5.19768 6.81382 5.44176 7.05789L9.99985 11.6159L14.5579 7.05786C14.8019 6.81378 15.1977 6.81378 15.4418 7.05785Z"
      fill="currentColor"
    />
  </svg>
);

// Close icon (matches icon-close.svg)
export const CloseIcon = ({ className = '' }: { className?: string }) => (
  <svg className={className} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.48006 2.9797C3.67533 2.78444 3.99191 2.78444 4.18717 2.9797L8.50029 7.29281L12.8134 2.9797C13.0087 2.78444 13.3252 2.78444 13.5205 2.9797C13.7158 3.17496 13.7158 3.49154 13.5205 3.68681L9.20739 7.99992L13.5205 12.313C13.7158 12.5083 13.7158 12.8249 13.5205 13.0201C13.3252 13.2154 13.0087 13.2154 12.8134 13.0201L8.50029 8.70703L4.18717 13.0201C3.99191 13.2154 3.67533 13.2154 3.48006 13.0201C3.2848 12.8249 3.2848 12.5083 3.48006 12.313L7.79318 7.99992L3.48006 3.68681C3.2848 3.49154 3.2848 3.17496 3.48006 2.9797Z"
      fill="currentColor"
    />
  </svg>
);
